/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Tasks_TitleInputs */

const en_my_tasks_title = /** @type {(inputs: My_Tasks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Tasks`)
};

const pt_br2_my_tasks_title = /** @type {(inputs: My_Tasks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minhas Atividades`)
};

/**
* | output |
* | --- |
* | "My Tasks" |
*
* @param {My_Tasks_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const my_tasks_title = /** @type {((inputs?: My_Tasks_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Tasks_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_my_tasks_title(inputs)
	return pt_br2_my_tasks_title(inputs)
});